<template>
  <section class="flex column">
    <div>
      <h3>{{ isEdit ? 'Editar': 'Criar' }} Conversão Personalizada</h3>
    </div>
    <section v-if="!loading" class="box flex-1 w100 margin-top-s">
      <div class="box-content">
        <div class="flex row w100">
          <div class="item flex-1 w100">
            <label>Nome da Conversão:</label>
            <input
              class="input margin-top-s"
              v-model="newCustomConversion.name"
            />
          </div>
          <div class="item margin-top-s flex-1 w100">
            <label>Plataforma:</label>
            <select class="input" v-model="newCustomConversion.platform">
              <option value="">Seleciona</option>
              <option
                v-for="(f, index) in listPlataform"
                :key="index"
                :value="f.value"
                :selected="f.value === newCustomConversion.platform"
              >
                {{ f.name }}
              </option>
            </select>
          </div>
        </div>
        <div
          v-if="newCustomConversion.platform === 'GADS'"
          class="flex margin-top-s row"
        >
          <div class="item ">
            <label>Conversion Id:</label>
            <input
              class="input margin-top-s"
              v-model="newCustomConversion.conversion_id"
            />
          </div>
          <div class="item ">
            <label>Rótulo da Conversão:</label>
            <input
              class="input margin-top-s"
              v-model="newCustomConversion.conversion_label"
            />
          </div>
          <div class="item ">
            <label>Valor da Conversão:</label>
            <money 
              class="input margin-top-s" 
              v-model="newCustomConversion.conversion_value" v-bind="money">
            </money>
          </div>
        </div>
        <div
          v-if="newCustomConversion.platform === 'FBADS'"
          class="flex margin-top-s row"
        >
          <div class="item margin-top-s flex-1 w100">
            <label>Evento Padrão:</label>
            <select class="input" v-model="newCustomConversion.default_conversion">
              <option value=""></option>
              <option
                v-for="(f, index) in listEventsFaceBook"
                :key="index"
                :value="f.value"
                :selected="f.value === newCustomConversion.default_conversion"
              >
                {{ f.name }}
              </option>
            </select>
          </div>
          <div class="item">
            <label>Nome do Evento (Conversão Personaliza):</label>
            <input
              class="input margin-top-s"
              v-model="newCustomConversion.conversion_label"
            />
          </div>
          
          <div class="item w100">
            <label>Nome do Produto:</label>
            <input
              class="input margin-top-s"
              v-model="newCustomConversion.conversion_product_name"
            />
          </div>
          <div class="item">
            <label>Valor da Conversão:</label>
            <money 
              class="input margin-top-s" 
              v-model="newCustomConversion.conversion_value" v-bind="money">
            </money>
          </div>
        </div>
      </div>
    </section>

    
    <div v-if="loading" class="box flex w100">
      <div class="box-content flex w100">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>
    </div>
    
    <section v-if="isEdit" class="flex margin-top-l">
      <h3>Acionadores</h3>
    </section>
    <section v-if="isEdit" class="box flex-1 w100 margin-top-s">
      <div class="box-content">
        <div class="flex w100">
          <div class="flex column w100">
            <div class="item">
              <div class="button primary" @click="openModalActionEdit()">
                Adicionar Acionador
              </div>
            </div>
            
            <div class="item flex-1 w100">
              <div class="list-itens flex column w100">
                <div
                  class="box flex-1 w100 step-item"
                  v-for="(fs, index) in conversionActives"
                  :key="index"
                >
                  <div class="box-content">
                    <div class="flex-1 w100">
                      <div class="flex middle row">
                        <div class="flex-3">
                          <div class="flex middle row">
                            <div class="flex-1 name">
                              <div>Tipo: {{ _decode_name_action(fs.type_action) }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="action">
                          <div class="flex end">
                            <div class="button primary" @click="openModalActionEdit(fs)">
                              EDITAR
                            </div>
                            <div
                              class="button primary"
                              @click="openToDelete(fs.id)"
                              style="margin-left: 8px"
                            >
                              DELETAR
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="flex w100 ">
                          <div v-if="false" class="flex-1 flex w100">
                            <logical-expression-builder
                              :initialOptions="opcoesIniciais"
                              @save="processarExpressao"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isEmptyActives" class="box flex w100">
        <div class="box-content">
          <p>
            Não encontramos nenhum acionador. Crie seu primeiro acionador para começar a disparar sua Conversão.
          </p>
        </div>
      </div>

      <div v-if="loadingActives" class="flex w100">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>
    </section>

    <section class="flex margin-top-s">
      <div class="button secondary" @click="$router.go(-1)">
        Voltar 
      </div>
      <div class="button primary" style="margin-left:8px" @click="createOrUpdateCustomConversion()">
        Salvar
      </div>
    </section>

    <!-- modal create / edit -->
    <modal
      :title="titleModalAction"
      :show="showModalCreateOrUpdate"
      @close="closeModalActionEdit()"
    >
      <div class="content flex " slot="content">
        <div class="flex column w100">
          <form class="w100" :key="`${newActive.id}-form`">
            <div class="flex-1">
              <div class="margin-top-s flex-1">
                <label>Tipo de Acionador:</label>
                <select class="input" v-model="newActive.type_action" :key="newActive.type_action">
                  <option value="">Seleciona</option>
                  <option
                    v-for="(f, index) in listActives"
                    :key="index"
                    :value="f.value"
                    :selected="f.value === newActive.type_action"
                  >
                    {{ f.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="flex-1 w100 margin-top-s">
              <div class="margin-top-s">
                <div v-if="newActive.type_action == 'PAGEVIEW'" class="flex column">
                  <div class="flex w100 column margin-top-s">
                    <label>Campo</label>
                    <select class="input" v-model="newActive.custom_fields.field">
                      <option value="">Seleciona</option>
                      <option
                        v-for="(f, index) in listValuesUrl"
                        :key="index"
                        :value="f.value"
                        :selected="f.value === newActive.custom_fields.field"
                      >
                        {{ f.name }}
                      </option>
                    </select>
                  </div>
                  <div class="flex w100 column margin-top-s">
                    <label>Operador</label>
                    <select class="input" v-model="newActive.custom_fields.operator">
                      <option value="">Seleciona</option>
                      <option
                        v-for="(f, index) in listOperators"
                        :key="index"
                        :value="f.value"
                        :selected="f.value === newActive.custom_fields.operator"
                      >
                        {{ f.name }}
                      </option>
                    </select>
                  </div>
                  <div class="flex w100 column margin-top-s">
                    <label>Valor</label>
                    <input
                      class="input margin-top-s"
                      v-model="newActive.custom_fields.value"
                    />
                  </div>
                </div>
                <div v-if="newActive.type_action == 'PAGEVIEW-TIME'" class="flex">
                    <div class="flex w100 column margin-top-s">
                    <label>Tempo</label>
                    <select class="input" v-model="newActive.custom_fields.value">
                      <option value="">Seleciona</option>
                      <option
                        v-for="(f, index) in listTimePageview"
                        :key="index"
                        :value="f.value"
                        :selected="f.value === newActive.custom_fields.value"
                      >
                        {{ f.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div v-if="newActive.type_action == 'SCROLL'" class="flex">
                  <div class="flex w100 column margin-top-s">
                    <label>Scroll</label>
                    <select class="input" v-model="newActive.custom_fields.value">
                      <option value="">Seleciona</option>
                      <option
                        v-for="(f, index) in listScrollPage"
                        :key="index"
                        :value="f.value"
                        :selected="f.value === newActive.custom_fields.value"
                      >
                        {{ f.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div v-if="newActive.type_action == 'LEAD'" class="flex">
                </div>
                <div v-if="newActive.type_action == 'PURCHASE'" class="flex">
                  <div class="flex w100 column margin-top-s">
                    <label>Nome do Produto</label>
                    <input
                      class="input margin-top-s"
                      v-model="newActive.custom_fields.value"
                    />
                  </div>
                </div>
                <div v-if="newActive.type_action == 'CLICK'" class="flex">
                  <div class="flex w100 column margin-top-s">
                    <label>Adicionar classe ao elemento via HTML:</label>
                    <input
                      class="input margin-top-s"
                      v-model="newActive.custom_fields.value"
                    />
                  </div>
                </div>
                <div v-if="newActive.type_action == 'VIEW-CONTENT'" class="flex">
                  <div class="flex w100 column margin-top-s">
                    <label>Adicionar classe ao elemento via HTML:</label>
                    <input
                      class="input margin-top-s"
                      v-model="newActive.custom_fields.value"
                    />
                  </div>
                </div>
                <div v-if="newActive.type_action == 'HOVER'" class="flex">
                  <div class="flex w100 column margin-top-s">
                    <label>Adicionar classe ao elemento via HTML:</label>
                    <input
                      class="input margin-top-s"
                      v-model="newActive.custom_fields.value"
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="flex w100 center margin-top-l">
            
            <div class="button primary" @click="createOrUpdateCustomConversionActive()">
              {{isEdit ? 'SALVAR': 'CRIAR'}}
            </div>

          </div>
        </div>
      </div>
    </modal>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalDelete"
      description="Você tem certeza que deseja deletar esse Acionador?"
      @cancel="
        showModalDelete = false;
        selectedActiveId = null;
      "
      @accept="deleteCustomConversionActive(selectedActiveId)"
    ></modal-confirm>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");

import { Money } from 'v-money'

import { mapState } from "vuex";
import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";
import LogicalExpressionBuilder from "@/components/logical/LogicalExpressionBuilder";

import {
  getCustomConversion,
  updateCustomConversion,
  // deleteCustomConversion,
  createCustomConversion,
  getCustomConversionActives,
  createCustomConversionActive,
  updateCustomConversionActive,
  deleteCustomConversionActive
} from "@/services/customConversion";

const EMPTY_CUSTOM_CONVER = {
  name: "",
  platform: "FBADS",
  default_conversion: '',
  conversion_id: '',
  conversion_label: '',
  conversion_value: '',
  conversion_product_name: '',
};

const EMPTY_ACTIVE = {
  type_action: "",
  custom_fields: {}
};


export default {
  name: "custom-conversion-new",
  components: {
    Modal,
    ModalConfirm,
    Money,
    LogicalExpressionBuilder,
  },
  props: ["conv_id"],
  data() {
    return {
      loading: false,
      loadingActives: false,
      showModalCreateOrUpdate: false,
      showModalDelete: false,
      selectedActiveId: null,
      newCustomConversion: Object.assign({}, EMPTY_CUSTOM_CONVER),
      newActive: Object.assign({}, EMPTY_ACTIVE),
      listPlataform: [
        { name: "Facebook (META)", value: "FBADS" },
        { name: "Google", value: "GADS" },
      ],
      listActives: [
        { name: "Visita em Página", value: "PAGEVIEW" },
        { name: "Tempo de Visita em Página", value: "PAGEVIEW-TIME" },
        { name: "Scroll de página", value: "SCROLL" },
        // { name: "Lead", value: "LEAD" },
        // { name: "Compra", value: "PURCHASE" },
        { name: "Clique em Botão", value: "CLICK" },
        { name: "Visualização de elementos", value: "VIEW-CONTENT" },
        { name: "Passou o mouse sobre o elemento", value: "HOVER" },
        // { name: "Player de Vídeo", value: "PLAY" },
        // { name: "Tempo de Player em Vídeo", value: "PLAY-TIME" },
        // { name: "Chamada em URL", value: "URL-GET" },
      ],
      listEventsFaceBook: [
        { name: "Click", value: "Click" },
        { name: "PageView", value: "PageView" },
        { name: "ViewContent", value: "ViewContent" },
        { name: "AddToCart", value: "AddToCart" },
        { name: "InitiateCheckout", value: "InitiateCheckout" },
        { name: "AddPaymentInfo", value: "AddPaymentInfo" },
        { name: "Purchase", value: "Purchase" },
        { name: "Register", value: "Register" },
        { name: "Subscribe", value: "Subscribe" },
      ],
      listOperators: [
          { name: "Contém", value: "content" },
          { name: "Não Contém", value: "nocontent" },
      ],
      listValuesUrl: [
          { value: 'url', name: 'Url' },
          { value: 'utm_source', name: 'utm_source' },
          { value: 'utm_content', name: 'utm_content' },
          { value: 'utm_medium', name: 'utm_medium' },
          { value: 'utm_campaign', name: 'utm_campaign' },
          { value: 'utm_term', name: 'utm_term' },
          { value: 'src', name: 'src' },
          { value: 'sck', name: 'sck' },
      ],
      listTimePageview: [
          { value: '15S', name: '15 segundos' },
          { value: '30S', name: '30 segundos' },
          { value: '60S', name: '60 segundos' },
          { value: '120S', name: '120 segundos' },
      ],
      listScrollPage: [
          { value: '25', name: '25%' },
          { value: '50', name: '50%' },
          { value: '75', name: '75%' },
          { value: '100', name: '100%' },
      ],
      conversionActives: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    };
  },
  mounted() {
    if (this.conv_id) {
      this.getCustomConversion();
      this.getCustomConversionActives()
    }
  },
  watch: {
    'newActive.type_action': {
      deep: true,
      handler() {
        if (['CLICK', 'VIEW-CONTENT', 'HOVER'].includes(this.newActive.type_action)) {
          if (!this.newActive.custom_fields.value) {
            this.newActive.custom_fields.value = this.randomName()
          }
        } else if (this.newActive && !this.newActive.id) {
          this.newActive.custom_fields.value = ''
        }
      }
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    titleModalAction() {
      return this.newActive.id? 'Editar Acionador' : 'Criar Acionador'
    },
    isEmpty() {
      return this.totalconversionActives === 0 && !this.loading;
    },
    isEmptyActives() {
      return this.totalconversionActives === 0 && !this.loading;
    },
    isEdit() {
      if (this.newCustomConversion && this.newCustomConversion.id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    _decode_name_action(action) {
      var _m_action = this.listActives.reduce((map, item) => {
        map[item.value] = item.name;
        return map;
      }, {});

      return _m_action[action] || action
    },
    randomName() {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        return 'UT'+Array.from({length: 8}, () => chars[Math.floor(Math.random() * chars.length)]).join('');
    },
    openModalActionEdit(ac) {
      if (ac) {
        this.newActive = ac
      } else {
        this.newActive = Object.assign({}, EMPTY_ACTIVE)
      }

      this.showModalCreateOrUpdate = true
    },
    closeModalActionEdit() {
      this.showModalCreateOrUpdate = false
    },
    openToDelete(sl) {
      this.showModalDelete = true;
      this.selectedActiveId = sl;
    },
    createOrUpdateCustomConversion() {
        if(!this.newCustomConversion.id) {
          this.createCustomConversion()
        } else {
          this.updateCustomConversion()
        }
    }, 
    createOrUpdateCustomConversionActive() {
        if(!this.newActive.id) {
          this.createCustomConversionActive()
        } else {
          this.updateCustomConversionActive()
        }
    }, 
    getCustomConversion() {
      this.loading = true;
      getCustomConversion(this.conv_id)
        .then((result) => {
          this.newCustomConversion = result;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createCustomConversion() {
      let params = {
        name: this.newCustomConversion.name,
        platform: this.newCustomConversion.platform,
        default_conversion: this.newCustomConversion.default_conversion,
        conversion_id: this.newCustomConversion.conversion_id,
        conversion_label: this.newCustomConversion.conversion_label,
        conversion_value: this.newCustomConversion.conversion_value,
        conversion_product_name: this.newCustomConversion.conversion_product_name,
      };

    createCustomConversion(params)
          .then((result) => {
            this.$toast.success({
              title: "Sucesso",
              message: "Conversão Personalizada criada com sucesso",
            });

            this.newCustomConversion = result;
            // send to edit conversion
            this.$router.push({ name: "CustomConversionEdit", params: { conv_id: result.id } });
          })
          .catch(() => {
            this.$toast.error({
              title: "Erro",
              message: "Ocorreu algum problema",
            });
        });
    },
    updateCustomConversion() {
      let params = {
        name: this.newCustomConversion.name,
        platform: this.newCustomConversion.platform,
        default_conversion: this.newCustomConversion.default_conversion,
        conversion_id: this.newCustomConversion.conversion_id,
        conversion_label: this.newCustomConversion.conversion_label,
        conversion_value: this.newCustomConversion.conversion_value,
        conversion_product_name: this.newCustomConversion.conversion_product_name,
      };

      updateCustomConversion(this.conv_id, params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Conversão Personalizada editada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    getCustomConversionActives() {
      this.loadingActives = true;
      getCustomConversionActives(this.conv_id)
        .then((result) => {
          this.conversionActives = result.actives;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loadingActives = false;
        });
    },
    createCustomConversionActive() {
      let params = {
        type_action: this.newActive.type_action,
        custom_fields: this.newActive.custom_fields,
      };
      createCustomConversionActive(this.conv_id, params)
        .then((result) => {
          this.conversionActives.push(result);

          this.$toast.success({
            title: "Sucesso",
            message: "Ativador criada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.closeModalActionEdit()
        })
    },
    updateCustomConversionActive() {
      let params = {
        type_action: this.newActive.type_action,
        custom_fields: this.newActive.custom_fields,
      };

      updateCustomConversionActive(this.conv_id, this.newActive.id, params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Ativador editada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    deleteCustomConversionActive(convActiveId) {
      deleteCustomConversionActive(this.conv_id, convActiveId)
        .then(() => {
          this.conversionActives = this.conversionActives.filter(e => e.id !== convActiveId)
          this.$toast.success({
            title: "Sucesso",
            message: "Ativador deletado com sucesso",
          });


        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.selectedActiveId = null;
          this.showModalDelete = false
        })
    },
  },
};
</script>

<style lang="scss" scoped>
.list-itens {
  .box + .box {
    margin-top: 8px;
    margin-left: 0px !important;
  }
}

.grid-flex .box + .box,
.flex .box + .box {
  margin-left: 0px;
}

.name {
  max-width: 400px;
  width: 400px;
  min-width: 400px;
  padding-right: 16px;
}
.step-item {
  border-radius: 8px;
  border: 1px solid #c3c3c3;
  margin-top: 8px;
}
</style>
